import React from 'react';

import styles from './styles.module.css';

export function AdminCardHeader({
  left,
  center,
  right
}: {
  left?: React.ReactNode;
  center?: React.ReactNode;
  right?: React.ReactNode;
}) {
  return (
    <div className={styles.adminHeader}>
      {left && <div className={styles.adminHeaderLeft}>{left}</div>}
      {center && <div className={styles.adminHeaderCenter}>{center}</div>}
      <div className={styles.adminHeaderRight}>{right}</div>
    </div>
  );
}

export function AdminCardBody({ children }: { children?: React.ReactNode }) {
  return <div className={styles.adminBodyWrapper}>{children}</div>;
}

export function AdminTableBody({ children }: { children?: React.ReactNode }) {
  return <div className={styles.adminTableWrapper}>{children}</div>;
}

export function AdminCardForm({ children }: { children?: React.ReactNode }) {
  return (
    <div className={styles.adminFormWrapper}>
      <div className={styles.adminFormGrid}>{children}</div>
    </div>
  );
}

export function AdminCardButtons({ children }: { children?: React.ReactNode }) {
  return <div className={styles.adminButtonsContainer}>{children}</div>;
}
